import * as Sentry from '@sentry/browser';
import config from 'config';

export const initializeSentry = user => {
  const { locale, countryName } = user;

  if (config.sentryDsn && process.env.NODE_ENV) {
    try {
      Sentry.init({
        dsn: `${config.sentryDsn}`,
        environment: process.env.NODE_ENV,
      });
    } catch (e) {
      console.log(`[Sentry] Error in initialization - ${e}`); // eslint-disable-line no-console
    }

    try {
      Sentry.configureScope(scope => {
        scope.setUser({ locale, countryName });
      });
    } catch (e) {
      console.log(`[Sentry] Error setting user - ${e}`); // eslint-disable-line no-console
    }
  }
};
